<template>
  <div class="row">
    <BModal
      id="modal-create-offer-attribute"
      title="Create Attribute"
      @ok="handleSubmit"
    >
      <BForm>
        <div class="row">
          <div class="col-md-12">
            <BFormGroup label="Type">
              <Multiselect v-model="payload.type" :options="typeOptions" />
            </BFormGroup>
          </div>

          <div class="col-md-12">
            <BFormGroup label="Label FR">
              <BFormInput v-model="payload.label_fr" />
            </BFormGroup>
          </div>
          <div class="col-md-12">
            <BFormGroup label="Label EN">
              <BFormInput v-model="payload.label_en" />
            </BFormGroup>
          </div>
        </div>
      </BForm>
    </BModal>
    <div class="col-md-12">
      <div class="card">
        <div
          class="card-header d-flex justify-content-between align-items-center"
        >
          <h4 class="card-title">Offer Attributes</h4>
          <div>
            <b-button variant="success" @click="handleExport">Export</b-button>
            <b-button variant="info" @click="openModal">Create</b-button>
          </div>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <BTable
              :items="offerAttributes"
              :fields="fields"
              :busy="isTableBusy"
            >
              <div slot="table-busy" class="text-center my-2">
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </BTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  BTable,
  BSpinner,
  BButton,
  BForm,
  BFormGroup,
  BFormInput
} from "bootstrap-vue";
import Multiselect from "vue-multiselect";

export default {
  components: {
    BTable,
    BSpinner,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    Multiselect
  },
  data() {
    return {
      isTableBusy: true,
      offerAttributes: [],
      fields: ["id", "type", "label_fr", "label_en"],
      payload: {
        type: "",
        label_en: "",
        label_fr: ""
      },
      typeOptions: [
        "category",
        "experience",
        "schedule",
        "certification",
        "specialization",
        "education",
        "skill"
      ]
    };
  },
  created() {
    this.$http
      .get("/enroll_admin/offer-attribute")
      .then(({ data }) => (this.offerAttributes = data))
      .finally(() => (this.isTableBusy = false));
  },
  methods: {
    openModal() {
      this.$bvModal.show("modal-create-offer-attribute");
    },
    handleExport() {
      this.$http.get("/enroll_admin/offer-attribute").then(({ data }) => {
        const url = window.URL.createObjectURL(
          new Blob([JSON.stringify(data, null, 2)])
        );
        const a = document.createElement("a");
        a.href = url;
        a.setAttribute("download", "offer-attributes.json");
        document.body.appendChild(a);
        a.click();
      });
    },
    handleSubmit(event) {
      event.preventDefault();
      this.$http
        .post("/enroll_admin/offer-attribute", this.payload)
        .then(() => {
          this.$nextTick(() => {
            this.$bvModal.hide("modal-create-offer-attribute");
          });
        })
        .catch(({ response }) => {
          if (response.status === 422) {
            Object.values(response.data).forEach(message => {
              this.$bvToast.toast(message, {
                title: "Error",
                autoHideDelay: 3000,
                variant: "danger"
              });
            });
          }
        });
    }
  }
};
</script>
